"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useState } from "react";
import { formatToFixedLength, trimToDecimals } from "@intents-explorer/shared-api/format-to-fixed-length";
import { getTokenIcon, getSymbolIcon } from "@intents-explorer/shared-api/tokens";
import { cn } from "../lib/cn";
import { ChainIcon } from "./chain-icon";
import { useTokens } from "./tokens-provider";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";
export function Price(t0) {
  const $ = _c(20);
  const {
    price,
    className,
    length: t1,
    defuseAssetId,
    type,
    usdAmount,
    usdLength: t2,
    showUsdAmount: t3,
    isPriceHidden: t4,
    fallbackSymbol,
    fallbackChain
  } = t0;
  const length = t1 === undefined ? 6 : t1;
  const usdLength = t2 === undefined ? 5 : t2;
  const showUsdAmount = t3 === undefined ? true : t3;
  const isPriceHidden = t4 === undefined ? false : t4;
  let t5;
  if ($[0] !== className) {
    t5 = cn("flex items-center gap-4", className);
    $[0] = className;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== defuseAssetId || $[3] !== fallbackChain || $[4] !== fallbackSymbol || $[5] !== type) {
    t6 = <TokenIcon defuseAssetId={defuseAssetId} type={type} fallbackSymbol={fallbackSymbol} fallbackChain={fallbackChain} />;
    $[2] = defuseAssetId;
    $[3] = fallbackChain;
    $[4] = fallbackSymbol;
    $[5] = type;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== defuseAssetId || $[8] !== fallbackSymbol || $[9] !== isPriceHidden || $[10] !== length || $[11] !== price || $[12] !== showUsdAmount || $[13] !== usdAmount || $[14] !== usdLength) {
    t7 = <PriceText fallbackSymbol={fallbackSymbol} price={price} defuseAssetId={defuseAssetId} length={length} isPriceHidden={isPriceHidden} usdAmount={usdAmount} usdLength={usdLength} showUsdAmount={showUsdAmount} />;
    $[7] = defuseAssetId;
    $[8] = fallbackSymbol;
    $[9] = isPriceHidden;
    $[10] = length;
    $[11] = price;
    $[12] = showUsdAmount;
    $[13] = usdAmount;
    $[14] = usdLength;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
export function PriceText(t0) {
  const $ = _c(28);
  const {
    price,
    fallbackSymbol,
    defuseAssetId,
    length: t1,
    className,
    isPriceHidden: t2,
    usdAmount,
    usdLength: t3,
    showUsdAmount: t4
  } = t0;
  const length = t1 === undefined ? 6 : t1;
  const isPriceHidden = t2 === undefined ? false : t2;
  const usdLength = t3 === undefined ? 5 : t3;
  const showUsdAmount = t4 === undefined ? true : t4;
  const token = useTokens()[defuseAssetId];
  const symbol = token?.symbol ?? fallbackSymbol ?? undefined;
  const decimals = token?.decimals ?? 0;
  let t5;
  if ($[0] !== length || $[1] !== price) {
    t5 = formatToFixedLength(price, length);
    $[0] = length;
    $[1] = price;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const displayPrice = t5;
  let t6;
  if ($[3] !== decimals || $[4] !== price) {
    t6 = trimToDecimals(price, decimals);
    $[3] = decimals;
    $[4] = price;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const fullPrice = t6;
  const fullPriceWithCurrency = symbol !== undefined && symbol !== "" ? `${fullPrice} ${symbol}` : fullPrice;
  let t7;
  if ($[6] !== className) {
    t7 = cn("text-sm whitespace-nowrap", className);
    $[6] = className;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = isPriceHidden ? "" : displayPrice;
  let t9;
  if ($[8] !== symbol) {
    t9 = symbol !== undefined && symbol !== "" && <span> {symbol}</span>;
    $[8] = symbol;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t7 || $[11] !== t8 || $[12] !== t9) {
    t10 = <span className={t7}>{t8}{t9}</span>;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const priceContent = t10;
  let t11;
  if ($[14] !== displayPrice || $[15] !== fullPrice || $[16] !== fullPriceWithCurrency || $[17] !== isPriceHidden || $[18] !== priceContent) {
    t11 = isPriceHidden ? <Tooltip><TooltipTrigger className="relative cursor-default text-base" asChild={true}>{priceContent}</TooltipTrigger><TooltipContent>The amount is hidden for security reasons</TooltipContent></Tooltip> : displayPrice === fullPrice ? <div>{priceContent}</div> : <Tooltip><TooltipTrigger className="relative cursor-default text-base" asChild={true}>{priceContent}</TooltipTrigger><TooltipContent>{fullPriceWithCurrency}</TooltipContent></Tooltip>;
    $[14] = displayPrice;
    $[15] = fullPrice;
    $[16] = fullPriceWithCurrency;
    $[17] = isPriceHidden;
    $[18] = priceContent;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== isPriceHidden || $[21] !== showUsdAmount || $[22] !== usdAmount || $[23] !== usdLength) {
    t12 = !isPriceHidden && <UsdAmount usdAmount={usdAmount} usdLength={usdLength} showUsdAmount={showUsdAmount} />;
    $[20] = isPriceHidden;
    $[21] = showUsdAmount;
    $[22] = usdAmount;
    $[23] = usdLength;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t11 || $[26] !== t12) {
    t13 = <div className="relative flex flex-col">{t11}{t12}</div>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}
export function TokenIcon(t0) {
  const $ = _c(32);
  const {
    defuseAssetId,
    type,
    className,
    fallbackSymbol,
    fallbackChain
  } = t0;
  const tokens = useTokens();
  const token = tokens[defuseAssetId];
  const chain = token?.chain ?? fallbackChain ?? undefined;
  const symbol = token?.symbol ?? fallbackSymbol ?? undefined;
  let t1;
  if ($[0] !== defuseAssetId || $[1] !== symbol || $[2] !== token || $[3] !== tokens) {
    t1 = token === undefined && symbol !== undefined && symbol !== "" ? getSymbolIcon(tokens, symbol) : getTokenIcon(tokens, defuseAssetId);
    $[0] = defuseAssetId;
    $[1] = symbol;
    $[2] = token;
    $[3] = tokens;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const tokenIcon = t1;
  const [tokenIconLoading, setTokenIconLoading] = useState(true);
  let t2;
  if ($[5] !== className) {
    t2 = cn("relative h-8 min-h-8 w-8 min-w-8", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== tokenIconLoading) {
    t3 = tokenIconLoading && <div className="bg-brand-grey/25 absolute h-8 w-8 animate-pulse rounded-full" />;
    $[7] = tokenIconLoading;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = tokenIconLoading && "opacity-0";
  let t5;
  if ($[9] !== t4) {
    t5 = cn("h-8 min-h-8 w-8 min-w-8", t4);
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = symbol ?? "Unknown token icon";
  let t7;
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setTokenIconLoading(false);
    };
    t8 = () => {
      setTokenIconLoading(false);
    };
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t6 || $[15] !== tokenIcon) {
    t9 = <TooltipTrigger asChild={true}><Image width={32} height={32} className={t5} src={tokenIcon} alt={t6} onLoad={t7} onError={t8} /></TooltipTrigger>;
    $[13] = t5;
    $[14] = t6;
    $[15] = tokenIcon;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== defuseAssetId) {
    t10 = <TooltipContent>{defuseAssetId}</TooltipContent>;
    $[17] = defuseAssetId;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <Tooltip>{t9}{t10}</Tooltip>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== chain) {
    t12 = chain !== undefined && chain !== "" && <ChainIcon className="bg-background dark:border-border absolute -right-2 -bottom-2 rounded-sm p-0.5 shadow-sm dark:border" chain={chain} />;
    $[22] = chain;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== type) {
    t13 = type === "INTENTS" && <Tooltip><TooltipTrigger asChild={true}><Image width={16} height={16} className="bg-background dark:border-border absolute -top-2 -right-2 rounded-sm p-0.5 shadow-sm dark:border" src="/icons/network/near-green.svg" alt="NEAR Intents" /></TooltipTrigger><TooltipContent>The token is on NEAR Intents contract</TooltipContent></Tooltip>;
    $[24] = type;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t11 || $[27] !== t12 || $[28] !== t13 || $[29] !== t2 || $[30] !== t3) {
    t14 = <div className={t2}>{t3}{t11}{t12}{t13}</div>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
    $[29] = t2;
    $[30] = t3;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
}
function UsdAmount(t0) {
  const $ = _c(16);
  const {
    usdAmount,
    usdLength: t1,
    showUsdAmount: t2
  } = t0;
  const usdLength = t1 === undefined ? 5 : t1;
  const showUsdAmount = t2 === undefined ? false : t2;
  if (usdAmount === undefined || usdAmount === null || usdAmount === "") {
    return null;
  }
  let t3;
  if ($[0] !== usdAmount || $[1] !== usdLength) {
    t3 = formatToFixedLength(usdAmount, usdLength);
    $[0] = usdAmount;
    $[1] = usdLength;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const displayUsdAmount = t3;
  let t4;
  if ($[3] !== usdAmount) {
    t4 = trimToDecimals(usdAmount, 4);
    $[3] = usdAmount;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const fullUsdAmount = t4;
  const t5 = showUsdAmount && "opacity-100";
  let t6;
  if ($[5] !== t5) {
    t6 = cn("text-muted-foreground absolute top-[calc(100%-1px)] left-0 text-[0.625rem] font-medium whitespace-nowrap opacity-0 transition-opacity delay-200 duration-500", t5);
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== displayUsdAmount || $[8] !== t6) {
    t7 = <TooltipTrigger asChild={true}><span className={t6}>~${displayUsdAmount}</span></TooltipTrigger>;
    $[7] = displayUsdAmount;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== displayUsdAmount || $[11] !== fullUsdAmount) {
    t8 = fullUsdAmount !== "" && displayUsdAmount !== fullUsdAmount && <TooltipContent>~${fullUsdAmount}</TooltipContent>;
    $[10] = displayUsdAmount;
    $[11] = fullUsdAmount;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <Tooltip>{t7}{t8}</Tooltip>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}